import React from "react";

/**
 * KYC/document status pill. Extracted from the copy in KycReviewDetailPage /
 * KycQueuePage and extended with a 4th `not_uploaded` state for the per-clinic
 * roll-up dialog (the queue never surfaces missing docs, so it never needed it).
 */
const KycStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const base = "inline-flex items-center rounded-full text-xs font-semibold px-2.5 py-0.5 border";
  if (status === "verified") {
    return <span className={`${base} bg-green-50 border-green-200 text-green-700`}>Verified</span>;
  }
  if (status === "rejected") {
    return <span className={`${base} bg-red-50 border-red-200 text-red-700`}>Rejected</span>;
  }
  if (status === "submitted") {
    return <span className={`${base} bg-yellow-50 border-yellow-200 text-yellow-800`}>Under review</span>;
  }
  return <span className={`${base} bg-slate-50 border-slate-200 text-slate-400`}>Not uploaded</span>;
};

export default KycStatusBadge;
